import { InjectionToken } from '@angular/core';

import { IThingDirectoryService } from '../services/thing-directory/thing-directory-interface';

export const THING_DIRECTORY_SERVICE = new InjectionToken<IThingDirectoryService>('ThingDirectoryService');
